import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { createVideo, editVideo } from "../../../api/endpoints/VideoEndpoints";
import { Video } from "../../../models/Video";

export default function useCreateOrEditVideo() {
  return useMutation<
    { id: number },
    AxiosError,
    { video: Video; operation: "create" | "edit" }
  >({
    mutationKey: ["create-or-edit-video"],
    mutationFn: ({ video, operation }) =>
      operation === "create" ? createVideo(video) : editVideo(video),
  });
}
